import React, { useCallback } from 'react';
import { capitalizeFirstLetter, List, PencilIcon, RawButton } from '@common-fe/common-fe';

import { BankAccountField } from '@/modules/employer/components/SetupEmployer/FinancialDetails/BankInformation/BankAccountField';
import { BankInfo } from '@/modules/employer/components/SetupEmployer/SetupEmployer.types';

interface Props {
  bank: BankInfo;
  onView: (id: string) => void;
  onEdit: (id: string) => void;
}

export const EmployerReactivationBankListItem: React.FC<Props> = ({ bank, onView, onEdit }) => {
  const handleView = useCallback(() => {
    onView(bank.id);
  }, [bank.id, onView]);

  const handleEdit = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    onEdit(bank.id);
  }, [bank.id, onEdit]);

  return (
    <List.Item testId={`bank-list_item_${bank.id}`} onClick={handleView}>
      <List.Item.Text flex={1.2} testId={`bank-list_item_${bank.id}_description`}>
        {bank.description}
      </List.Item.Text>

      <List.Item.Text flex={1.2} testId={`bank-list_item_${bank.id}_type`} weight="normal">
        <BankAccountField
          last4Value={bank.accountNumberLast4}
          accountNumberLength={bank.accountNumberLength}
          accountId={bank.id}
        />
      </List.Item.Text>

      <List.Item.Text flex={1} testId={`bank-list_item_${bank.id}_type`} weight="normal">
        {capitalizeFirstLetter(bank.accountCategory)}
      </List.Item.Text>

      <List.Item.Text flex={0.2} testId={`bank-list_item_${bank.id}_type`} weight="normal">
        <RawButton data-testid={`bank-list_item_${bank.id}_edit-button`} onClick={handleEdit}>
          <PencilIcon />
        </RawButton>
      </List.Item.Text>
    </List.Item>
  );
};
